import React from 'react';
import { arrivalLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmArrivalCumulativeChart(props) {
  const { arrival, increment, d0_date, d2_date } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Arrival'
      arrival={arrival}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      arrivalColor={arrivalLineColor}
      showArrival={true}
      showClosure={false}
    />
  );
}
